import React from 'react';
import { Link } from 'lucide-react';
import { UpdateTransportModalData } from '@/constants/Interfaces/CommonInterfaces';

interface InstructorTransportViewProps {
  data: UpdateTransportModalData;
}

const InstructorTransportView: React.FC<InstructorTransportViewProps> = ({
  data
}) => {
  const { lesson } = data;

  return (
    <div className='space-y-4 w-full max-w-full px-4 md:px-6 pb-4 md:pb-6'>
      <div className='flex items-center justify-between mb-2'>
        <h2 className='text-lg md:text-xl font-bold text-gray-800'>
          Transport Details
        </h2>
      </div>

      <div className='overflow-x-auto'>
        <table className='table-fixed w-full border border-gray-300 rounded-xl text-sm text-center mx-auto mb-4 min-w-[1000px]'>
          <colgroup>
            <col style={{ width: '180px' }} />
            <col style={{ width: '150px' }} />
            <col style={{ width: '70px' }} />
            <col style={{ width: '220px' }} />
            <col style={{ width: '120px' }} />
            <col style={{ width: '120px' }} />
            <col style={{ width: '120px' }} />
            <col style={{ width: '120px' }} />
          </colgroup>
          <thead className='bg-blue-100 text-gray-800'>
            <tr>
              <th className='py-2 px-2.5 border'>Instructor</th>
              <th className='py-2 px-2.5 border'>Client</th>
              <th className='py-2 px-2.5 border'># Party</th>
              <th className='py-2 px-2.5 border'>Hotel</th>
              <th className='py-2 px-2.5 border'>Vehicle</th>
              <th className='py-2 px-2.5 border'>Pick-up numbers</th>
              <th className='py-2 px-2.5 border'>Pickup Time</th>
              <th className='py-2 px-2.5 border'>Return Time</th>
            </tr>
          </thead>
          <tbody className='bg-white divide-y divide-gray-200'>
            <tr className='bg-white'>
              <td className='border px-2 py-1.5 align-middle'>
                <div className='px-2 py-1.5 bg-gray-50 rounded border text-center break-words whitespace-normal'>
                  {lesson.instructor_name}
                </div>
              </td>
              <td className='border px-2 py-1.5 align-middle'>
                <div className='px-2 py-1.5 bg-gray-50 rounded border text-center break-words whitespace-normal'>
                  {lesson.client_name}
                </div>
              </td>
              <td className='border px-2 py-1.5 align-middle'>
                <div className='px-2 py-1.5 bg-gray-50 rounded border text-center'>
                  {lesson.number_in_party}
                </div>
              </td>
              <td className='border px-2 py-1.5 align-middle'>
                <div className='px-2 py-1.5 bg-gray-50 rounded border min-h-10 min-w-10 text-center break-words whitespace-normal'>
                  {lesson?.hotel?.name}
                </div>
                <span className='block mt-1 text-xs text-slate-600'>
                  {lesson?.hotel?.google_map_link && (
                    <a
                      href={lesson?.hotel?.google_map_link}
                      target='_blank'
                      rel='noopener noreferrer'
                      className='text-blue-600 underline flex items-center justify-center gap-1'
                    >
                      Google Map Link
                      <Link size={15} />
                    </a>
                  )}
                </span>
              </td>
              <td className='border px-2 py-1.5 align-middle'>
                <div className='px-2 py-1.5 bg-gray-50 rounded border text-center break-words whitespace-normal'>
                  {(lesson as any)?.car?.name || 'N/A'}
                </div>
              </td>
              <td className='border px-2 py-1.5 align-middle'>
                <div className='px-2 py-1.5 bg-gray-50 rounded border text-center'>
                  {lesson.transport_pax || 0}
                </div>
              </td>
              <td className='border px-2 py-1.5 align-middle'>
                <div className='px-2 py-1.5 bg-gray-50 rounded border text-center'>
                  {lesson.pickup_time || 'N/A'}
                </div>
              </td>
              <td className='border px-2 py-1.5 align-middle'>
                <div className='px-2 py-1.5 bg-gray-50 rounded border text-center'>
                  {lesson.pickup_end_time || 'N/A'}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className='overflow-x-auto'>
        <table className='table-fixed w-full border border-gray-300 rounded-xl text-sm text-center mx-auto mb-4'>
          <colgroup>
            <col style={{ width: '100%' }} />
          </colgroup>
          <thead className='bg-blue-100 text-gray-800'>
            <tr>
              <th className='py-2 px-2.5 border'>Comment</th>
            </tr>
          </thead>
          <tbody className='bg-white divide-y divide-gray-200'>
            <tr className='bg-white'>
              <td className='border px-2 py-1.5 align-middle'>
                <div className='w-full px-3 py-2 bg-gray-50 rounded border text-left min-h-[60px] whitespace-pre-wrap'>
                  {lesson.transport_comments || 'No comments'}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InstructorTransportView;
